import {
  ELIGIBILITY_BRANCHING,
  GUIDED_SELLING_QUESTION1,
  GUIDED_SELLING_QUESTION2,
  PAST_ED_DIAGNOSIS,
  PREGNANCY
} from "config/tags";
import {
  CLINICAL_PROGRAM,
  CORE_PRODUCT,
  NOT_ELIGIBLE_BULEMIA,
  NOT_ELIGIBLE_PREGNANCY,
  PREMIUM_PRODUCT
} from "./constants";
import { findAnswerByQuestionTag } from "utils/questions";

export const getResultsPageUniV3 = (answers, questions) => {
  const firstAnswer = findAnswerByQuestionTag(
    GUIDED_SELLING_QUESTION1,
    answers,
    questions
  );
  const secondAnswer = findAnswerByQuestionTag(
    GUIDED_SELLING_QUESTION2,
    answers,
    questions
  );
  const answer =
    firstAnswer && secondAnswer ? `${firstAnswer},${secondAnswer}` : "";

  // Clinical Eligible - did not answer guided selling Qs.
  const eligibilityBranching = questions.find(q =>
    q.tags.includes(ELIGIBILITY_BRANCHING)
  );
  if (eligibilityBranching && !answer) {
    const isPregnant =
      findAnswerByQuestionTag(PREGNANCY, answers, questions)?.toLowerCase() ===
      "yes";
    const hasEatingDisorder =
      findAnswerByQuestionTag(
        PAST_ED_DIAGNOSIS,
        answers,
        questions
      )?.toLowerCase() === "yes";

    if (isPregnant) {
      return NOT_ELIGIBLE_PREGNANCY;
    } else if (hasEatingDisorder) {
      return NOT_ELIGIBLE_BULEMIA;
    } else {
      return CLINICAL_PROGRAM;
    }
  }

  switch (answer) {
    case "D,W":
    case "V,W":
    case "W,V":
    case "W,W":
      return PREMIUM_PRODUCT;
    default:
      return CORE_PRODUCT;
  }
};

export const getIsClinicEligibleUni3 = (answers, questions) => {
  if (getResultsPageUniV3(answers, questions) === CLINICAL_PROGRAM) {
    return true;
  }

  return false;
};
